import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {CardDeck} from 'reactstrap';
import OitProgressChart from './OitProgressChart';
import dashboardActionCreators from '../../store/dashboard/action-creators';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import DashboardTile from './DashboardTile';
import DashboardReports from './DashboardReports';
import {
  reportsDueAcknowledgement,
  reportsDueApprove,
  reportsDueReview,
  reportsDueSubmit,
  reportsDueSubmitForFto,
  reportsWaitingApprove,
  reportsWaitingReview,
  reportsWaitingSubmit,
} from '../../store/reports/selectors';
import reportsActionCreators from '../../store/reports/action-creators';
import riskAlertsActionCreators from "../../store/risk-alerts/action-creators";
import riskAlertsSelectors from "../../store/risk-alerts/selectors";
import Modal from "../../../shared/ui/Modal";
import DashboardTasks from "./DashboardTasks";
import trainingPhasesActionCreators from "../../store/training-phases/action-creators";
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import ftoTasksActions from "../../store/ftos/fto-tasks";
import taskTrainingActionCreators from "../../store/task-training/action-creators";
import {taskResponsesLateAck, taskResponsesWaitingAck} from "../../store/task-training/selectors";
import taskGroupsActions from '../../store/task-groups/action-creators/index';
import DashboardOitReport from "./DashboardOitReport";
import TimeAnalytics from "../analytics/TimeAnalytics";
import DashboardAnalyticsReport from "./DashboardAnalyticsReport";
import DashboardStatisticsReport from "./DashboardStatisticsReport";
import DashboardFtoReport from "./DashboardFtoReport";
import DashboardFtoStatisticsReport from "./DashboardFtoStatisticsReport";
import DashboardLogReport from "./DashboardLogReport";
import DashboardTaskTraining from "./DashboardTaskTraining";
import ftosActionCreators from "../../store/ftos/action-creators";
import AnalyticsBanner from "./AnalyticsBanner";
import CommonCreateReport from "../common/CommonCreateReport";
import CustomForm from "../../../shared/components/form/CustomForm";
import ReportViewSplit from "../reports/ReportViewSplit";
import ModalSplit from "../../../shared/ui/ModalSplit";

class FtocDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTaskResponseAckLoading: false,
      oitComment: '',
      lateOitComment: '',
      showCreateReportDialog: false,
      showChangeReportPhaseDialog: false,
      currentChangPhase: null,
      currentChangePhaseReportGuid: null,
    };
  }

  componentDidMount() {
    this.props.fetchActiveOits();
    this.props.fetchReports();
    this.props.fetchRiskAlerts();
    this.props.fetchMyTaskResponses();
    this.props.fetchTaskGroups();
    this.props.fetchFtos();
  }

  openReport(report) {
    this.props.setIsViewingReport(report);
  }

  addReport(report) {
    if (report.status === 'scheduled') {
      this.props.addScheduledReport(report.guid, report.type);
    } else {
      this.props.editReport(report.guid);
    }
  }

  ackTaskResponse(taskResponse, commentField) {
    let comment = this.state[commentField];
    this.setState({
      isTaskResponseAckLoading: true
    });
    this.props.akcResponse(taskResponse.guid, comment)
      .then(() => {

        this.setState({
          isTaskResponseAckLoading: false,
          [commentField]: ''
        });
      })
  }

  updateComment(oitComment) {
    this.setState({
      oitComment
    })
  }

  updateLateComment(lateOitComment) {
    this.setState({
      lateOitComment
    })
  }

  onChangePhase(report) {
    this.setState({
      showChangeReportPhaseDialog: true,
      currentChangePhaseReportGuid: report.guid,
      currentChangePhase: {
        phase: report.trainingPhaseGuid,
        datetime: report.responses[0] && report.responses[0].datetime ? (report.responses[0].datetime.split('T')[0]): null
      }
    })
  }

  get changePhaseConfig() {
    return {
      fields: {
        phase: {
          type: 'select',
          label: 'Phase',
          value: 'value',
          optionLabel: 'label',
          options: this.props.trainingPhases.map(tp => ({
            value: tp.guid,
            label: tp.header
          }))
        },
        datetime: {
          type: 'date',
          label: 'Report date (optional)'
        }
      }
    }
  }

  get isLoading() {
    return (
      this.props.isLoadingReports.includes('fetchReports') ||
      this.props.isLoadingOits.includes('fetchOits') ||
      this.props.isLoadingRiskAlerts.includes('fetchRiskAlerts')
    );
  }

  get hasLateApprovalWarnings() {
    return (
      this.props.reportsDueApprove && this.props.reportsDueApprove.length !== 0
    );
  }

  get hasLateSubmitWarnings() {
    return this.props.reportsDueSubmit && this.props.reportsDueSubmit.length;
  }

  render() {
    return (
      <Fragment>
        <div className="app-content-header">
          <h4 className="title">Dashboard</h4>
          <p className="sub-title text-muted">
            <button onClick={() => this.setState({showCreateReportDialog: true})} className="button primary small">Create report</button> FTO Coordinator
          </p>
        </div>
        <div className="app-content dashboard">
          <LoadingOverlay isLoading={this.isLoading}>
            <CardDeck>
              <DashboardTile
                link="/oits"
                icon="users"
                title={`${this.props.oitShortLabel} Forms Progress`}
                color="#5e4037"
              />

              <DashboardTile
                link="/task-training"
                icon="tasks"
                title={`${this.props.oitShortLabel} Task Progress`}
                color="#e4b95d"
              />

              <DashboardTile
                link="/reports"
                icon="paperclip"
                title={`Late forms`}
                color="#de3737"
              />

              <DashboardTile
                link="/active-ftos"
                icon="user-secret"
                title={`View ${this.props.ftoShortLabel} assignment`}
                color="#333"
              />
            </CardDeck>

            <div className="dashboard-reports-deck">
              <DashboardReports
                showOitName
                nextReportActive
                icon="list-alt"
                viewReportIcon="check"
                title="Pending My Approval"
                addReportLabel="Approve"
                nextReportLabel="Next report for approval"
                reports={[...(this.props.reportsDueApprove || []),...(this.props.reportsWaitingApprove || [])]}
                noReportsMessage="No reports pending my approval"
                onViewReport={report => this.openReport(report)}
              />

              <DashboardReports
                showOitName
                nextReportActive
                icon="list-alt"
                viewReportIcon="edit"
                title="FORMS TO COMPLETE"
                addReportLabel="Complete new form"
                nextReportLabel="Next report for submission"
                reports={[...(this.props.reportsDueSubmit || []), ...(this.props.reportsWaitingSubmit || [])]}
                noReportsMessage="No reports pending submission"
                onViewReport={report => this.addReport(report)}
              />

              <DashboardTasks
                icon="tasks"
                taskResponses={[...(this.props.taskResponsesLateAck || []), ...(this.props.taskResponsesWaitingAck || [])]}
                taskGroupsMap={this.props.taskGroupsMap}
                title="Task Acknowledgement"
                isLoading={this.state.isTaskResponseAckLoading}
                ackComment={this.state.oitComment}
                updateComment={this.updateComment.bind(this)}
                onAck={(taskResponse) => this.ackTaskResponse(taskResponse, 'oitComment')}
              />
            </div>

            <AnalyticsBanner />

            <div className="dashboard-reports-deck">
              <DashboardOitReport
                title="View Total Training Hours by Phase & Total Program"
                multiple={true}
              >
                {(oitGuids) => <TimeAnalytics oitGuids={oitGuids}/>}
              </DashboardOitReport>
              <DashboardOitReport
                title="View Remedial Training Minutes by Observation & Phase"
                multiple={true}
              >
                {(oitGuids) => <DashboardAnalyticsReport oitGuids={oitGuids} type="time-spend"/>}
              </DashboardOitReport>
              <DashboardOitReport
                title={`View ${this.props.oitShortLabel} Performance Statistics Against Average`}
                multiple={true}
              >
                {(oitGuids) => <DashboardStatisticsReport oitGuid={oitGuids}/>}
              </DashboardOitReport>
            </div>
            <div className="dashboard-reports-deck">
              <DashboardOitReport
                title={`View ${this.props.oitShortLabel} GRADING ANALYTICS`}
                multiple={true}
              >
                {(oitGuids) => <DashboardAnalyticsReport oitGuids={oitGuids} type="rating" compact={false}/>}
              </DashboardOitReport>
              <DashboardFtoReport
                title={`View ${this.props.ftoShortLabel} Grading Statistics Against Department Average`}
                multiple={true}
              >
                {(ftoGuids) => <DashboardFtoStatisticsReport ftoGuids={ftoGuids}/>}
              </DashboardFtoReport>
              <DashboardOitReport
                title="VIEW FIELD OCCURRENCE LOG"
                multiple={true}
              >
                {(oitGuids) => <DashboardLogReport oitGuids={oitGuids}/>}
              </DashboardOitReport>
              <DashboardOitReport
                title="View Training Task Progress"
              >
                {(oitGuid) => <DashboardTaskTraining oitGuid={oitGuid}/>}
              </DashboardOitReport>
            </div>

            <OitProgressChart />
          </LoadingOverlay>
        </div>
        <ModalSplit
          isOpen={!!this.props.viewingReport}
          onClose={() => this.props.setIsViewingReport(null)}
          title={this.props.viewingReport && this.props.viewingReport.formName}
          fullscreen={true}
        >
          <ReportViewSplit  report={this.props.viewingReport} />
        </ModalSplit>
        <Modal
          isOpen={this.state.showCreateReportDialog}
          onClose={() => this.setState({
            showCreateReportDialog: false
          })}
          title={"Create Report"}
          size={'small'}
        >
          {this.state.showCreateReportDialog && (
            <CommonCreateReport onFinish={() => this.setState({showCreateReportDialog: false})} />
          )}
        </Modal>
        <Modal
          isOpen={this.state.showChangeReportPhaseDialog}
          onClose={() => this.setState({
            showChangeReportPhaseDialog: false
          })}
          title="Change phase">
          {this.state.showChangeReportPhaseDialog && (
            <CustomForm
              config={this.changePhaseConfig}
              initialValues={this.state.currentChangePhase}
              onSubmit={(data) => this.updateReportPhase(data)}
            />
          )}
        </Modal>
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isLoading: state.dashboard.isLoading,
    isLoadingReports: state.reports.isLoading,
    isLoadingOits: state.oits.isLoading,
    isLoadingRiskAlerts: state.riskAlerts.isLoading,
    viewingReport: state.reports.viewingReport,
    reportsDueAcknowledgement: reportsDueAcknowledgement(state),
    reportsWaitingApprove: reportsWaitingApprove(state),
    reportsDueApprove: reportsDueApprove(state),
    reportsWaitingReview: reportsWaitingReview(state),
    reportsDueReview: reportsDueReview(state),
    riskAlertsReports: riskAlertsSelectors.riskAlertsReports(state),
    reportsWaitingSubmit: reportsWaitingSubmit(state),
    reportsDueSubmit: reportsDueSubmit(state),
    reportsDueSubmitFto: reportsDueSubmitForFto(state),
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
    canViewLateFtoNotifications: departmentSettingsSelectors.canViewLateFtoNotifications(state),
    canViewLateOitAck: departmentSettingsSelectors.canViewLateOitAck(state),
    taskResponsesLateAck: taskResponsesLateAck(state),
    taskResponsesWaitingAck: taskResponsesWaitingAck(state),
    taskGroupsMap: state.taskGroups.taskGroupMap
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchReports: (scope) => {
      return dispatch(reportsActionCreators.fetchReports(scope));
    },
    fetchActiveOits: () => {
      return dispatch(dashboardActionCreators.fetchActiveOits());
    },
    fetchRiskAlerts: () => {
      return dispatch(riskAlertsActionCreators.fetchRiskAlerts());
    },
    setIsViewingReport: (report) => {
      return dispatch(reportsActionCreators.setIsViewingReport(report));
    },
    addScheduledReport: (reportGuid, type) => {
      return dispatch(trainingPhasesActionCreators.addScheduledReport(reportGuid, type));
    },
    editReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.editReport(reportGuid));
    },
    fetchMyTaskResponses: () => {
      return dispatch(ftoTasksActions.fetchFtocTaskResponses());
    },
    akcResponse: (taskResponseGuid, comment) => {
      return dispatch(taskTrainingActionCreators.ackResponse(taskResponseGuid, comment))
    },
    fetchTaskGroups: () => {
      return dispatch(taskGroupsActions.fetchTaskGroups());
    },
    fetchFtos: () => {
      return dispatch(ftosActionCreators.fetchFtos());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FtocDashboard);
